export const JOIN_EXISTING_COMPANY_HELP_URL = 'https://help.routific.com/en/articles/27-how-to-join-an-existing-company';
export const PREDICTED_TRAFFIC_HELP_ARTICLE_URL = 'https://docs.google.com/document/d/1G-c7C5HCvPXhhkEjDpDYH87YC2_svHTLaa6y3SoOCyw';
export const PRICING_PLAN_DETAILS = 'https://www.routific.com/v3-pricing';
export const RT_TOS_URL = 'https://www.routific.com/tos';
export const RT_PRIVACY_URL = 'https://www.routific.com/privacy';
